import Vue from 'vue';
import Router from 'vue-router';
import * as navGuards from '@/router/navigationGuards';
import { DEPARTMENT } from '@/enum/UserDepartments';

// views
import Dashboard from '@/views/Dashboard.vue';
import ClientDetail from '@/views/ClientDetail.vue';
import ClientList from '@/views/ClientList.vue';
import BusinessList from '@/views/BusinessList.vue';
import BusinessDetail from '@/views/BusinessDetail.vue';
import DocutaxRequestList from '@/views/DocutaxRequestList.vue';
import DocutaxSubmissionList from '@/views/DocutaxSubmissionList.vue';
import EarlyBirdApplication from '@/views/EBApplication.vue';
import EarlyBirdEnrollmentList from '@/views/EBEnrollmentList.vue';
import OfficeList from '@/views/OfficeList.vue';
import OfficeDetail from '@/views/OfficeDetail.vue';
import PayReferralSelector from '@/views/PayReferralSelector.vue';
import PayClientReferral from '@/views/PayClientReferral.vue';
import PayBusinessReferral from '@/views/PayBusinessReferral.vue';
import ReferralList from '@/views/ReferralList.vue';
import PriorYearReports from '@/views/priorYearReports/index.vue';
import PriorYearReportDashboard from '@/views/priorYearReports/Dashboard.vue';
import PriorYearReportNewVsReturning from '@/views/priorYearReports/NewVsReturning.vue';
import Reports from '@/views/reports/index.vue';
import ReportDashboard from '@/views/reports/Dashboard.vue';
import ReportNewVsReturning from '@/views/reports/NewVsReturning.vue';
import ReportScheduling from '@/views/reports/Scheduling.vue';
import ReportAlerts from '@/views/reports/Alerts.vue';
import TransactionDetail from '@/views/TransactionDetail.vue';
import TransactionList from '@/views/TransactionList.vue';
import UserList from '@/views/settings/Users.vue';
import UserDetail from '@/views/settings/UserDetail.vue';
import W2Generator from '@/views/W2Generator.vue';

Vue.use(Router);

const routes = [
  {
    path: '/settings/user/:userId',
    name: 'user-detail',
    component: UserDetail,
    beforeEnter: navGuards.requiresManager(),
  },
  {
    path: '/settings/user',
    name: 'user-list',
    component: UserList,
    beforeEnter: navGuards.requiresManager(),
  },
  {
    path: '/transaction',
    name: 'transaction-list',
    component: TransactionList,
    beforeEnter: navGuards.requiresManager(DEPARTMENT.ACCOUNTANT),
  },
  {
    path: '/transaction/:transactionId',
    name: 'transaction-detail',
    component: TransactionDetail,
    beforeEnter: navGuards.requiresManager(DEPARTMENT.ACCOUNTANT),
  },
  {
    path: '/reports',
    component: Reports,
    children: [
      {
        path: '',
        redirect: '/reports/dashboard',
        beforeEnter: navGuards.requiresManager(),
      },
      {
        path: 'dashboard',
        component: ReportDashboard,
        name: 'reportDashboard',
        default: true,
        beforeEnter: navGuards.requiresManager(),
      },
      {
        path: 'newVsReturning',
        component: ReportNewVsReturning,
        name: 'reportNewVsReturning',
        beforeEnter: navGuards.requiresManager(),
      },
      {
        path: 'scheduling',
        component: ReportScheduling,
        name: 'reportScheduling',
        beforeEnter: navGuards.requiresManager(),
      },
      {
        path: 'alerts',
        name: 'reportAlerts',
        component: ReportAlerts,
        beforeEnter: navGuards.requiresManager(),
      },
    ],
  },
  {
    path: '/prior-year-reports',
    component: PriorYearReports,
    children: [
      {
        path: '',
        redirect: '/prior-year-reports/dashboard',
        beforeEnter: navGuards.requiresManager(),
      },
      {
        path: 'dashboard',
        component: PriorYearReportDashboard,
        name: 'priorYearReportDashboard',
        default: true,
        beforeEnter: navGuards.requiresManager(),
      },
      {
        path: 'newVsReturning',
        component: PriorYearReportNewVsReturning,
        name: 'priorYearReportNewVsReturning',
        beforeEnter: navGuards.requiresManager(),
      },
    ],
  },
  {
    path: '/w2Generator',
    component: W2Generator,
    name: 'w2Generator',
  },
  {
    path: '/docutax/submission',
    component: DocutaxSubmissionList,
    name: 'docutaxSubmissionList',
  },
  {
    path: '/docutax/request',
    component: DocutaxRequestList,
    name: 'docutaxRequestList',
  },
  {
    path: '/raf/payout/',
    component: PayReferralSelector,
    name: 'payReferral',
  },
  {
    path: '/raf/payout/client/:entityId',
    component: PayClientReferral,
    name: 'payClientReferral',
  },
  {
    path: '/raf/payout/business/:entityId',
    component: PayBusinessReferral,
    name: 'payBusinessReferral',
  },
  {
    path: '/raf',
    component: ReferralList,
    name: 'referralList',
  },
  {
    path: '/clients/:id',
    component: ClientDetail,
    name: 'clientDetail',
  },
  {
    path: '/clients/',
    component: ClientList,
    name: 'clients',
  },
  {
    path: '/earlyBirdApplication/:clientId?',
    component: EarlyBirdApplication,
    name: 'earlyBirdApplication',
  },
  {
    path: '/earlyBirdEnrollment/',
    component: EarlyBirdEnrollmentList,
    name: 'earlyBirdEnrollment',
  },
  {
    path: '/businesses/',
    component: BusinessList,
    name: 'businesses',
    beforeEnter: navGuards.requiresManager(DEPARTMENT.ACCOUNTANT),
  },
  {
    path: '/businesses/:businessId',
    component: BusinessDetail,
    name: 'businessDetail',
    beforeEnter: navGuards.requiresManager(DEPARTMENT.ACCOUNTANT),
  },
  {
    path: '/offices/',
    component: OfficeList,
    name: 'offices',
    beforeEnter: navGuards.requiresManager(DEPARTMENT.ACCOUNTANT),
  },
  {
    path: '/offices/:officeId',
    component: OfficeDetail,
    name: 'officeDetail',
    beforeEnter: navGuards.requiresManager(DEPARTMENT.ACCOUNTANT),
  },
  {
    path: '/',
    component: Dashboard,
    name: 'dashboard',
  },
];

const router = new Router({
  routes,
});

export default router;
